export default "__VITE_ASSET__CSmp$4Ca__"